import type {Components, Theme} from '@mui/material/styles';
import {COLORS} from "~/style/colors-ts";

export const paperOverrides: Components<Theme>['MuiPaper'] = {
    defaultProps: {
        elevation: 1,
    },
    styleOverrides: {
        root: {
            backgroundColor: COLORS.white[900],
        },
    },
};
